import React, { useState } from 'react';
import styled from 'styled-components';
import {
  GlobalContainer,
  ContentContainer,
} from '../components/Container';
import ParagraphBig from '../components/ParagraphBig';
import ActionButton from '../components/ActionButton';

const VideoSection = styled.div`
  grid-area: 1 / 1 / 2 / 13;
`;

const TextSection = styled.div`
  margin-bottom: ${(props) => props.theme.constants.defaultContentMobile};

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    max-width: 75%;
    margin-bottom: ${(props) => props.theme.constants.defaultContent};
  }
`;

const VideoFrame = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: ${(props) => props.theme.colors.black};

  &::before {
    content: "";
    display: block;
    padding-bottom: calc(100% / (16 / 9));
  }

  & > iframe,
  & > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  & > img {
    object-fit: cover;
    transition: transform 0.3s ease-out;
  }

  &:hover > img {
    transform: scale(1.03);
  }
`;

const PlayButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const FeaturedVideo = ({
  title,
  text,
  youtubeId,
  poster,
}) => {
  const [playing, setPlaying] = useState(false);

  return (
    <GlobalContainer>
      <ContentContainer sequence>
        <VideoSection>
          <TextSection>
            <h2>{title}</h2>
            <ParagraphBig noMarginBottom>{text}</ParagraphBig>
          </TextSection>
          <VideoFrame>
            {playing ? (
              <iframe
                title={title}
                src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`}
                allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                allowFullScreen
              />
            ) : (
              <>
                <img src={poster} alt={title} />
                <PlayButton>
                  <ActionButton clickHandler={() => setPlaying(true)} />
                </PlayButton>
              </>
            )}
          </VideoFrame>
        </VideoSection>
      </ContentContainer>
    </GlobalContainer>
  );
};

export default FeaturedVideo;
